import * as React from "react";

const ThinArrowLeft = (props) => {
  return (
    <svg width="21px" height="70px" viewBox="0 0 21 70">
      <g stroke="none" strokeWidth="1" fill="#000000" fillRule="evenodd">
        <polygon points="21 2.04680851 19.8382979 0 0 34.9531915 19.8382979 70.0638298 21 67.8595745 2.32340426 34.9531915" />
      </g>
    </svg>
  );
};

export default ThinArrowLeft;



// WEBPACK FOOTER //
// ./src/components/Icons/ThinArrowLeft.jsx